import { render, staticRenderFns } from "./directSeeding.vue?vue&type=template&id=136a80c6&scoped=true&"
import script from "./directSeeding.vue?vue&type=script&lang=js&"
export * from "./directSeeding.vue?vue&type=script&lang=js&"
import style0 from "./directSeeding.vue?vue&type=style&index=0&id=136a80c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a80c6",
  null
  
)

export default component.exports